export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/backArrow.0ea10b8a.svg","height":24,"width":24};